import React, { useRef } from 'react';
import { a } from '@react-spring/three';
import { useSnowflakes, useSnowflake } from './use-snowflake';
const SnowFlake = ({ value, style }) => {
    const flake = useRef();
    useSnowflake(flake, { value });
    return (React.createElement(a.mesh, { position: value.startpoint, ref: flake, "material-opacity": style === null || style === void 0 ? void 0 : style.opacity },
        React.createElement("circleGeometry", { attach: "geometry", args: [value.radius, 128] }),
        React.createElement("meshBasicMaterial", { color: "white", transparent: true, attach: "material" })));
};
const Snow = (props) => {
    const { snowflakes } = useSnowflakes(props);
    return (React.createElement(a.group, null, snowflakes.map((snowflake, index) => {
        return React.createElement(SnowFlake, { key: index, value: snowflake, style: props.style });
    })));
};
export default Snow;
